import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { fetchAdminPackages } from "../../endpoints/API";
// import { useSelector } from "react-redux";

export const fetchPackage = async (setPackage, baseUrl, prodTestUrl) => {
  // const baseUrl = useSelector(selectBaseUrl);
  // const prodTestUrl = useSelector(selectProdTestUrl);
  try {
    const response = await fetchAdminPackages();
    if (response.statusText=="OK") {
      const data = response?.data;
      setPackage(data);
    } else {
      message.error("Failed to fetch package.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching package.");
  }
};
